// 轻量全局 Toast（不依赖组件树，任意模块可直接调用）
// 用法：toast('保存成功')  /  toast('出错了', 'error')
let container = null

function ensureContainer() {
  if (container) return container
  container = document.createElement('div')
  container.className = 'toast-root'
  container.style.cssText =
    'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:99999;display:flex;flex-direction:column;align-items:center;gap:8px;pointer-events:none;'
  document.body.appendChild(container)
  return container
}

function show(message, type = 'info', duration = 2200) {
  const root = ensureContainer()
  const el = document.createElement('div')
  const bg = type === 'success' ? '#07c160' : type === 'error' ? '#e8503c' : '#2e2117'
  el.style.cssText = `max-width:340px;padding:9px 18px;font-size:13px;color:#fff;background:${bg};border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.15);opacity:0;transform:translateY(-6px);transition:all .2s ease;`
  el.textContent = message
  root.appendChild(el)
  requestAnimationFrame(() => {
    el.style.opacity = '1'
    el.style.transform = 'translateY(0)'
  })
  setTimeout(() => {
    el.style.opacity = '0'
    el.style.transform = 'translateY(-6px)'
    setTimeout(() => el.remove(), 220)
  }, duration)
}

export const toast = {
  info: (msg) => show(msg, 'info'),
  success: (msg) => show(msg, 'success'),
  error: (msg) => show(msg, 'error')
}

export default toast
